import React, { PropTypes } from 'react';
import classNames from 'classnames'


const Loader = ({ loaded, children, className }) => (
  <div className={classNames("loader", loaded? "loaded" : "loading", className)}>
    { !loaded && (
      <div className="spinner">
        <div className="cube1"></div>
        <div className="cube2"></div>
      </div>
    )}
    <div className={classNames('fade', { show: loaded })}>{loaded && children}</div>
  </div>
);

Loader.propTypes = {
  loaded: PropTypes.bool.isRequired,
  children: PropTypes.any,
}

Loader.defaultProps = {
  loaded: false,
}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.js